import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {DatatableService} from '@common/datatable/datatable.service';
import {CurrentUser} from '@common/auth/current-user';
import {Toast} from '@common/core/ui/toast.service';
import {ActivatedRoute} from '@angular/router';
import {BackendErrorResponse} from '@common/core/types/backend-error-response';
import {HttpErrors} from '@common/core/http/errors/http-errors.enum';
import {LinkGroupService} from '../../../shared/link/link-group.service';
import {Messages} from '../../../messages.enum';
import {CrupdateLinkGroupModalComponent} from '../crupdate-link-group-modal/crupdate-link-group-modal.component';
import {LinkUsageService} from '../../../shared/link/link-usage.service';
import {LinkGroup} from '../../../shared/link/link-group';
import {Observable, Subscription} from 'rxjs';
import {LINK_GROUP_INDEX_FILTERS} from './link-group-index-filters';
import {ActiveAppSectionService} from '../../active-app-section.service';
import {WorkspacesService} from '@common/workspaces/workspaces.service';

@Component({
    selector: 'link-group-index',
    templateUrl: './link-group-index.component.html',
    styleUrls: ['./link-group-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatatableService],
})
export class LinkGroupIndexComponent implements OnInit, OnDestroy {
    groups$ = this.datatable.data$ as Observable<LinkGroup[]>;
    filters = LINK_GROUP_INDEX_FILTERS;
    private workspaceSub: Subscription;

    constructor(
        public datatable: DatatableService<LinkGroup>,
        public currentUser: CurrentUser,
        private linkGroups: LinkGroupService,
        private toast: Toast,
        private route: ActivatedRoute,
        private linkUsage: LinkUsageService,
        private activeSection: ActiveAppSectionService,
        private workspaces: WorkspacesService
    ) {}

    ngOnInit() {
        this.workspaceSub = this.workspaces.activeId$.subscribe(() => {
            this.setFilters();
        });
        this.datatable.init({
            uri: LinkGroupService.BASE_URI,
            staticParams: {
                with: ['user'],
                withCount: ['links'],
                userId: !this.showUserColumn()
                    ? this.currentUser.get('id')
                    : null,
            },
        });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }

    maybeDeleteSelectedGroups(groupIds?: number[]) {
        this.datatable.confirmResourceDeletion('link groups').subscribe(() => {
            this.linkGroups
                .delete(groupIds || this.datatable.selectedRows$.value)
                .subscribe(
                    () => {
                        this.datatable.reset();
                        this.toast.open(Messages.LINK_GROUP_DELETE_SUCCESS);
                    },
                    (errResponse: BackendErrorResponse) => {
                        this.toast.open(
                            errResponse.message || HttpErrors.Default
                        );
                    }
                );
        });
    }

    showCrupdateGroupModal(linkGroup?: LinkGroup) {
        this.datatable
            .openCrupdateResourceModal(CrupdateLinkGroupModalComponent, {
                linkGroup,
            })
            .subscribe(() => this.linkUsage.reload());
    }

    showUserColumn(): boolean {
        // show in admin and if active workspace is not personal
        return this.activeSection.admin || !!this.workspaces.activeId$.value;
    }

    private setFilters() {
        this.filters = LINK_GROUP_INDEX_FILTERS.filter(
            f => f.key !== 'user_id' || this.showUserColumn()
        );
    }
}
